export default __webpack_public_path__ + "static/media/edit_pencil.f77b01fb.svg";